import { render, staticRenderFns } from "./OverlayLoadingProgress.vue?vue&type=template&id=54e7b893"
import script from "./OverlayLoadingProgress.vue?vue&type=script&lang=js"
export * from "./OverlayLoadingProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports